import React, { useEffect, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';
import MaterialTable from 'material-table';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { MoreVertRounded } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NavLink, useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Cookies from 'js-cookie';
import { clearCookie, getPrivileges } from '../../../functions/Auth';
import API_PATH from "../../../constants/config.json";

import '../../../scss/components/_import_data.scss';
import TableIcons from '../../TableIcons';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}


let bcktName;
let uploadRetryCount = 0;
let s3UploadStatus = false;

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#ffffff',
      padding: '4px',
      color: '#3f3f46',
      maxWidth: '412px',
      border: '1px solid #e4e4e7',
      fontSize: '12px',
      fontFamily: 'Inter-Regular',
      boxSizing: 'border-box',
      boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
      borderRadius: '4px'
    },
  }))(Tooltip);

const ImportTable = props => {

    const theme = useTheme();
    let history = useHistory();
    const [showActions, setShowActions] = useState(false);
    const [actionsTop, setActionsTop] = useState(0);
    const [actionsLeft, setActionsLeft] = useState(0);
    const [filesList, setFilesList] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [fileToRemove, setFileToRemove] = useState(null);
    const [fileStationIdToRemove, setfileStationIdToRemove] = useState(null);
    const [getLoader,setLoaderDisable] = React.useState(false);
    const [importBtnStatus, setImportBtnStatus] = useState(1);
    const [filesImported, setFilesImported] = useState(0);
    const [filesStored, setFilesStored] = useState(0);
    const [stationsList, setStationsList] = useState([]);
    const [importloaderShow, setImportloaderShow] = useState('none');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [msgTitle, setMsgTitle] = useState(null);
    const [agencyBucket, setAgencyBucket] = useState('');
    const [idintityPool, setIdintityPool] = useState('');
    const [aswLogins, setAswLogins] = useState('');

    const [scrolled, setScrolled] = useState(false);
    const listFilesRef = useRef();
    
    const enteriesPerPage = 25;

    useEffect(() => {
        getBucket();
        getAswToken();
        if(props.details.length > 0) {
            setFilesList(props.details);
            setTotalItems(props.details.length);
            setImportBtnStatus(1);
            setFilesStored(0);
            setFilesImported(0);
             if(props.details.length > 0) {
                 let files = [...props.details];
                 let imp = 0;
                 let sto = 0;
                 files.forEach(function(it) {
                     if(it.file_status !== 'success') {
                         setImportBtnStatus(0);
                     }
                     if(it.dataType === 'File Storage') {
                         sto++;
                     } else
                         imp++;
                 })
                 setFilesImported(imp);
                 setFilesStored(sto);
             }
        } else {
            setTotalItems(0);
            setFilesStored(0);
            setFilesImported(0);
        }
        if(props.geojsonLayer) {
            fillStationsList();
        }
    }, [props.details])

    const getBucket = () => {
        try {
        axios({
            method: 'post',
            url: API_URL + API_PATH.getAWSs3BucketAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            bcktName = response.data;
            bcktName = bcktName.data;
            bcktName = bcktName.bucket_name;
            setAgencyBucket(bcktName);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }

    let aswData;
    const getAswToken = () => {
        try {
        axios({
            method: 'get',
            url: API_URL + API_PATH.getAWSs3TokenAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            aswData = response.data;
            aswData = aswData.data;
            setIdintityPool(aswData.IdentityPoolId);
            setAswLogins(aswData.Logins);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }


    const fillStationsList = async() => {
        var query = props.geojsonLayer.createQuery();
        query.outFields = ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude","display_name"];
        let results = await props.geojsonLayer.queryFeatures(query).then(function(results){     
            //slice array use to get the first 10 results             
            return results.features.map(function(feature) {
                return {
                key: "station_location",
                text: "("+feature.attributes.client_station_id+") "+((feature.attributes.display_name !='')?feature.attributes.display_name : feature.attributes.station_location),
                searchText : feature.attributes.client_station_id
                };
            });   
        })
        setStationsList(results);
    }


    const handleClickAway = () => {
        setShowActions(false);
    }

    const handleShowActions = (e,fileind,stationid) => {
        setShowActions(true);
        setFileToRemove(fileind);
        setfileStationIdToRemove(stationid);
        setActionsTop(e.pageY);
        setActionsLeft(e.pageX-112);
    }

    const removeRow = () => {
        let tmpdetails = [...props.details];
        tmpdetails = tmpdetails.filter((row) => row.uniqueID !== fileToRemove);
        props.setDetails(tmpdetails);
        if( fileStationIdToRemove !== "") {
            let tmp = [...props.mapLocation];
            let indst = tmp.findIndex( (loc) => loc.clent_Station_id === fileStationIdToRemove);
            if(indst >= 0) {
                tmp.splice(indst, 1);
                props.setMapLocation(tmp);
                props.changeMapView(tmp);
            }

        }
        setShowActions(false);
    }

    const importFileData = async () => {   
        setErrMsg(null);
        let details = props.details;
        let fileIndex = [];
        let batchIDArray = [];
        let file_ids;
        let OIDToken = Cookies.get('idToken');
        let bucketName = agencyBucket;
        AWS.config.region = 'us-west-2'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: idintityPool,
        Logins: {
            [aswLogins]: OIDToken
        }
        });

        let bucket = new AWS.S3({
        params: {
            Bucket: bucketName
        }
        });

        setImportloaderShow('block');

        // getting max batch id 
        try {
          //this code is import datafile for import list
          await axios({
            method: 'post',
            url: API_URL + API_PATH.getMaxBatchId,
            headers: {
                'agencyid': sessionStorage.getItem('agency_id'),
                'payload': Cookies.get('payload'),
            },
          }).then(async function (response) {
            if (response.status && response.status == '200') {
              let resp = response.data;
              let maxBatchId = resp.data[0] ? resp.data[0].nextval : null;
              for (let i = 0; i < details.length; i++) {
                //This Code is Used for Data file
                let fileStatusId = details[i].file_status_id;
                let fileTId = details[i].file_type_id;
                let originName = details[i].fileName;
                let sid = details[i].station_id;
                let username = Cookies.get('email');
                let objKey;
                let timeStams = new Date().getTime();
                let fileExe = details[i].file_exe;     
                objKey = username + '/' + details[i].fileName.replace(/(\.[\w\d_-]+)$/i, '_' + timeStams + '$1');
                let params = {
                    Key: objKey,
                    ContentType: details[i].file_exe,
                    Body: details[i].file_body
                };
                await bucket.putObject(params, async function (err, data) {             
                    if (err && err.message) {
                        setImportloaderShow('none');
                        setErrMsgType('custom_error')
                        setErrMsg('An error has ocurred while trying to upload your data. Please try and upload again.');
                        setMsgTitle('An error ocurred during upload');
                        setErrPopUp(true);
                    } else {
                        s3UploadStatus = true;
                        try {
                            //this code is import datafile for import list
                            await axios({
                            method: 'post',
                            data: {
                                file_status_id: fileStatusId,
                                file_type_id: fileTId,
                                origin_name: originName,
                                base_name: objKey,
                                station_id: sid,
                                username: username,
                                batch_id: maxBatchId,
                                bucket_name: bucketName
                            },
                            url: API_URL + API_PATH.dataFileAPI,
                            headers: {
                                'agencyid': sessionStorage.getItem('agency_id'),
                                'payload': Cookies.get('payload'),
                            },
                            }).then(async function (response) {
                                if (response.status && response.status == '200') {
                                    fileIndex.push(details[i].uniqueID);
                                    file_ids = response.data.file_id;
                                    batchIDArray.push(file_ids);
                                    removeUploadedFile(fileIndex);
                                    await listObjs(bucket).then(async result => {
                                        if (i === details.length - 1) {
                                            setImportloaderShow('none');
                                            props.setMapLocation([]);
                                            if (fileIndex.length > 0) {
                                                if (fileIndex.length === details.length) {
                                                    props.setDetails([]);
                                                    setFilesList([]);
                                                    uploadRetryCount = 0;
                                                    s3UploadStatus = false;
                                                    props.changeMapView([]);
                                                    setErrMsgType('custom_success');
                                                    setMsgTitle('Import complete');
                                                    setErrMsg('File import has been completed. View data in data management to approve or reject imported files.');
                                                    setErrPopUp(true);
                                                }
                                                else {
                                                    await removeUploadedFile(fileIndex);
                                                    uploadRetryCount = 0;
                                                    s3UploadStatus = false;
                                                }
                                            }
                                        }
                                    }).catch(err => {
                                        console.log(err)
                                    })
                                } else {
                                    console.log("Data file no import");
                                }
                            }).catch(async function (error) {
                                setImportloaderShow('none');
                                setErrMsgType('custom_error')
                                setErrMsg('An error has ocurred while trying to upload your data. Please try and upload again.');
                                setMsgTitle('An error ocurred during upload');
                                setErrPopUp(true);
                                if (error.response) {
                                    if (error.response.status && error.response.status == '401') {
                                    if (Cookies.get('email')) {
                                        clearCookie('email');
                                        clearCookie('payload');
                                        clearCookie('idToken');
                                        clearCookie('atexpiry');
                                    }
                                    history.push('/');
                                    }
                                }
                            })
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });     
              }
            } else {
              console.log("No batch id returned");
            }
          });
        } catch (error) {
            console.error(error);
        }
    }

    function listObjs(bucket) {
        return new Promise((resolve, reject) => {
        let prefix = Cookies.get('email');
        bucket.listObjects({
            Prefix: prefix
        }, function (err, data) {
            if (err) {
            console.log('ERROR: ' + err);
            } else {
            let objKeys = "";
            data.Contents.forEach(function (obj) {
                objKeys = obj.Key;
            });
            console.log(objKeys);
            resolve(true);
            }
        });
        })
    }

    const removeUploadedFile = (fileIndex = []) => {
        let tempArray = [];
        if (fileIndex.length > 0) {
            for (let i = 0; i < props.details.length; i++) {
                let indexFile = fileIndex.findIndex((uniqueID, index) => uniqueID === props.details[i].uniqueID)
                if (indexFile === -1) {
                    tempArray.push(props.details[i]);
                }
            }
            props.setDetails(tempArray);
        }
    }

    const handleCloseDialogueBox = () => {
        setErrMsg(null);
    }

    const handleScroll = () => {
        if (listFilesRef.current) {
          const { scrollTop } = listFilesRef.current.children[0].children[1].children[0].children[0].children[0].children[0].children[1];
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
    };
    const handleManageData = () =>{
        handleCloseDialogueBox();
        props.setShowImportTable(false);
        props.handleOpenDataManager();
    }
    return (
        <React.Fragment>
            <CssBaseline />
            <div className="import-files-main">
                <Container className="import-files-container" maxWidth="lg">
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                        value={0}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Import data" {...a11yProps(0)} id="filesTabb" data-testid="filesTab" />
                        </Tabs>
                        <div>
                            <img src={require('../../../assets/icons/close.svg')} onClick={() => props.setShowImportTable(false)} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={0}
                    >
                        <TabPanel value={0} index={0} dir={theme.direction} >
                        <div className={importloaderShow==='block' ? "table-cnt inactive" : "table-cnt"} >
                            {
                                importloaderShow==='block' &&
                                <div><CircularProgress /></div>
                            }
                            <div className="table-top">
                                <h3>Files - {totalItems} to be imported</h3>
                                <div>
                                    <p>Files imported: <label>{filesImported}</label></p>
                                    <p>Files stored: <label>{filesStored}</label></p>
                                </div>
                                <Button className="cancel-btn" disabled={importloaderShow==='block' ? true : false}><NavLink to={`/UsersDashboard?import=` + 1}>Add files</NavLink></Button>
                            </div>   
                            <div className={scrolled ? "table-container scrolled-el" : "table-container"} onScroll={handleScroll} ref={listFilesRef}>
                                <MaterialTable
                                    icons={TableIcons}
                                    title=""
                                    columns={[
                                    { title: '', field: '', width: '3%', 
                                        render: rowData =>
                                        rowData.file_status === 'success' ?
                                        <img src={require('../../../assets/icons/check-import-file.png')} />
                                        :
                                        (rowData.status && rowData.status.description) ?
                                        <HtmlTooltip
                                            title={
                                                rowData.status.title ? rowData.status.title + '. ' +rowData.status.description : rowData.status.description
                                            }
                                        >
                                        <img src={require('../../../assets/icons/warning-yellow.png')} />
                                        </HtmlTooltip>
                                        :
                                        <img src={require('../../../assets/icons/warning-yellow.png')} />
                                    },
                                    { title: 'File name', field: 'fileName', width: '30%',
                                        render: rowData =>
                                        <label title={rowData.fileName}>{rowData.fileName.length > 42 ? rowData.fileName.substring(0, 41)+'...' : rowData.fileName}</label>
                                    },
                                    { title: 'Station ID', field: 'sationId', width: '20%',
                                        render: rowData =>
                                        <Autocomplete
                                            disabled={rowData.file_size_status === 'error'}
                                            value={rowData.sationId}
                                            onChange={(event, newValue) => {
                                                // launched when an option is chosen or the clear icon clicked
                                                let tmpdet = [...props.details];
                                                tmpdet.forEach(function(it, ind) {
                                                    if(it.uniqueID === rowData.uniqueID) {
                                                        let stID = null;
                                                        let tmp = [...props.mapLocation];
                                                        if(newValue) {
                                                            tmp.push({ clent_Station_id: newValue.searchText });
                                                            let allstations = [...props.stationDetails];
                                                            allstations.forEach(function(st, ind) {
                                                                if(st.stationId === newValue.searchText){
                                                                    stID = st.station_id;
                                                                }
                                                            });
                                                        } else {
                                                            let indst = tmp.findIndex( (loc) => loc.clent_Station_id === it.sationId);
                                                            tmp.splice(indst, 1);
                                                        }
                                                        props.setMapLocation(tmp);
                                                        props.changeMapView(tmp);
                                                        tmpdet[ind].sationId = newValue ? newValue.searchText : "";
                                                        tmpdet[ind].file_status = newValue ? 'success' : 'error';
                                                        tmpdet[ind].station_id = newValue ? stID : 0;
                                                    }
                                                });
                                                props.setDetails(tmpdet);
                                            }}
                                            inputValue={rowData.sationId}
                                            onInputChange={(event, newInputValue) => {
                                                // launched when the user ins typing
                                                let tmpdet = [...props.details];
                                                if(newInputValue && newInputValue !== '') {
                                                    tmpdet.forEach(function(it, ind) {
                                                        if(it.uniqueID === rowData.uniqueID) {
                                                            tmpdet[ind].sationId = newInputValue;
                                                        }
                                                    });
                                                } 
                                                props.setDetails(tmpdet);
                                            }}
                                            options={stationsList}
                                            getOptionLabel={(option) => option.text}
                                            PaperComponent={({ children }) => (
                                                <Paper style={{position: "absolute", right: 0, width: "368px", overflow: "hidden", maxHeight: "270px", boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)", borderRadius: "6px"}}>{children}</Paper>
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} className={rowData.file_status !== 'success' && "warning-status" } />
                                            )}
                                            renderOption={(option, { inputValue }) => {
                                                const matches = match(option.text, inputValue);
                                                const parts = parse(option.text, matches);
                                                return (
                                                <div>
                                                    {parts.map((part, index) => (
                                                    <span key={index} className="station-item" style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                                        {part.text}
                                                    </span>
                                                    ))}
                                                </div>
                                                );
                                            }}
                                        />
                                    },
                                    { title: 'Vendor', field: 'vendor', width: '10%', },
                                    { title: 'Data type', field: 'dataType', width: '19%'},
                                    { title: 'Type', field: 'status', width: '10%',
                                        render: rowData =>
                                        <label className={rowData.dataType == 'File Storage' ? "type-status-storage" : "type-status-import"}>{rowData.dataType == 'File Storage' ? 'Storage' : 'Import'}</label>
                                    },
                                    { title: 'Actions', field: '', width: '8%', cellStyle: { textAlign: 'center' },
                                        render: rowData => 
                                        <MoreVertRounded className="actions-dots" onClick={(e) => handleShowActions(e,rowData.uniqueID,rowData.sationId)} /> 
                                    },
                                    ]}
                                    data={filesList ? filesList : []}
                                    totalCount={totalItems}
                                    options={{
                                        filtering: false,
                                        sorting: false,
                                        // paging: true,
                                        paging: false,
                                        pageSize: enteriesPerPage,
                                        pageSizeOptions: [0],
                                        search:false,
                                        emptyRowsWhenPaging: false,
                                        draggable: false
                                    }}
                                    components={
                                        getLoader &&
                                        {
                                            Body: (props) => (
                                            <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                                            )
                                        }
                                    }
                                />
                            </div>
                            <div className="buttons-cnt">
                                <Button className="cancel-btn" onClick={() => props.setShowImportTable(false)} >Cancel</Button>
                                {
                                    importloaderShow === 'block' ?
                                    <Button 
                                        className="blue-btn font-14" 
                                    >
                                        <CircularProgress />
                                    </Button>
                                    :
                                    <Button 
                                        className="blue-btn font-14" 
                                        disabled={importBtnStatus == 0 || props.details.length == 0 ? true : false}
                                        onClick={importFileData}
                                    >
                                            Import
                                    </Button>
                                }
                            </div>
                        </div>
                        </TabPanel>
                    </SwipeableViews>
                </Container>
            </div>
            {
                showActions &&
                <ClickAwayListener onClickAway={handleClickAway}>
                <div className="actions-panel" style={{top: actionsTop+'px', left: actionsLeft+'px'}}>
                        <div onClick={removeRow}>
                            <img src={require('../../../assets/icons/import-file-detele.png')} />
                            <label>Delete</label>
                        </div>
                    </div>
                </ClickAwayListener>
            }
            {
                errMsg && 
                <Dialog
                        open={errMsg}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        className="delete-popup"
                    >
                        <DialogContent>
                            <div className="error-container">
                                {
                                    errMsgType === 'custom_error' ?
                                    <label className="red-bg"><img src={require('../../../assets/icons/custom-error.svg')} /></label>
                                    :
                                    <label className="emerald-bg"><img src={require('../../../assets/icons/saved_successfully_modal.svg')} /></label>
                                }
                                <div>
                                    <label>{msgTitle}</label>
                                    <p>{errMsg}</p>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            {errMsgType == 'custom_success' ?<Button onClick={handleManageData} className="btn-manage-data-dialog" style={{padding:'0px !important'}}>
                                Manage data
                            </Button>:null}
                            <Button onClick={handleCloseDialogueBox} className="btn-manage-data-dismiss blue-btn font-14">
                                Dismiss
                            </Button>
                        </DialogActions>
                </Dialog>
            }
        </React.Fragment>
    )
}

export default ImportTable;